/**
 * Os periodos que o relatorio de sono oferece.
 *
 * O VOCABULARIO e o do `components/period` - quais atalhos existem e como cada um
 * vira intervalo sao decisao de la, compartilhada com as outras telas que escolhem
 * periodo. O que mora aqui e o que e DESTE relatorio: quais dos atalhos ele oferece,
 * o codigo de cada um no endereco, e o teto de cinco semanas.
 *
 * Antes desta separacao, a aritmetica de "ultimos 30 dias" existia aqui e de novo na
 * Adocao e Engajamento - duas contas para a mesma pergunta, livres para discordar.
 */
export const SLEEP_PERIODS = ['7d', '14d', '30d', 'month', 'last-month', 'custom'];
/**
 * O codigo de cada periodo no endereco. Ver `CodeTable` em `domain`.
 *
 * Os DIGITOS sao os mesmos de sempre, e tem de continuar sendo: eles estao gravados
 * no historico do navegador e em todo link ja compartilhado. O que mudou foram os
 * nomes internos ('mes' virou 'month'), que nao viajam.
 */
export const SLEEP_PERIOD_CODES = {
    '0': '7d',
    '1': '14d',
    '2': '30d',
    '3': 'month',
    '4': 'last-month',
    '5': 'custom'
};
/**
 * O teto: cinco semanas por pedido.
 *
 * E a janela do relatorio que o cliente usa, e e tambem uma protecao - o relatorio
 * le noite a noite de cada atleta, e um pedido de um ano para vinte e um deles varre
 * a tabela de medicoes inteira para produzir um PDF que ninguem le.
 *
 * O numero vive em DOIS lugares de proposito: aqui, para a tela avisar antes de
 * pedir, e no servidor, que e quem de fato recusa. A tela pode ser contornada; o
 * endpoint nao.
 */
export const SLEEP_MAX_DAYS = 35;
/** Os atalhos deste relatorio, na ordem em que aparecem no seletor. */
export const SLEEP_SHORTCUTS = SLEEP_PERIODS;
//# sourceMappingURL=sleep-report.periods.js.map